"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  generateMessageId: () => generateMessageId,
  isAppletAttachment: () => isAppletAttachment,
  isAppletAttachmentType: () => isAppletAttachmentType,
  isBlobAttachment: () => isBlobAttachment,
  isBlobAttachmentType: () => isBlobAttachmentType,
  isLinkPreviewAttachment: () => isLinkPreviewAttachment,
  isLinkPreviewAttachmentType: () => isLinkPreviewAttachmentType,
  loadMessages: () => loadMessages,
  loadMessagesGroups: () => loadMessagesGroups,
  parseMessagesDoc: () => parseMessagesDoc,
  withTotal: () => withTotal
});
module.exports = __toCommonJS(utils_exports);
var import_communication_types = require("@hcengineering/communication-types");
const COUNTER_BITS = 10n;
const RANDOM_BITS = 10n;
const MAX_SEQUENCE = (1n << COUNTER_BITS) - 1n;
let counter = 0n;
function makeBigIntId() {
  const ts = BigInt(Date.now());
  counter = counter < MAX_SEQUENCE ? counter + 1n : 0n;
  const random = BigInt(Math.floor(Math.random() * Number((1n << RANDOM_BITS) - 1n)));
  return ts << COUNTER_BITS + RANDOM_BITS | counter << RANDOM_BITS | random;
}
__name(makeBigIntId, "makeBigIntId");
function toBase64Url(bytes) {
  let s = "";
  for (const b of bytes) s += String.fromCharCode(b);
  const base64 = typeof btoa === "function" ? btoa(s) : Buffer.from(bytes).toString("base64");
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
__name(toBase64Url, "toBase64Url");
function generateMessageId() {
  const idBig = makeBigIntId();
  const buf = new Uint8Array(8);
  new DataView(buf.buffer).setBigUint64(0, idBig, false);
  return toBase64Url(buf);
}
__name(generateMessageId, "generateMessageId");
function isAppletAttachment(attachment) {
  return attachment.mimeType.startsWith("application/vnd.huly.applet.");
}
__name(isAppletAttachment, "isAppletAttachment");
function isLinkPreviewAttachmentType(mimeType) {
  return mimeType === import_communication_types.linkPreviewType;
}
__name(isLinkPreviewAttachmentType, "isLinkPreviewAttachmentType");
function isAppletAttachmentType(mimeType) {
  return mimeType.startsWith("application/vnd.huly.applet.");
}
__name(isAppletAttachmentType, "isAppletAttachmentType");
function isBlobAttachmentType(mimeType) {
  return !isLinkPreviewAttachmentType(mimeType) && !isAppletAttachmentType(mimeType);
}
__name(isBlobAttachmentType, "isBlobAttachmentType");
function isLinkPreviewAttachment(attachment) {
  return attachment.mimeType === import_communication_types.linkPreviewType;
}
__name(isLinkPreviewAttachment, "isLinkPreviewAttachment");
function isBlobAttachment(attachment) {
  return !isLinkPreviewAttachment(attachment) && !isAppletAttachment(attachment) && "blobId" in attachment.params;
}
__name(isBlobAttachment, "isBlobAttachment");
function withTotal(objects, total) {
  const length = total ?? objects.length;
  return Object.assign(objects, { total: length });
}
__name(withTotal, "withTotal");
async function loadMessagesGroups(client, cardId) {
  const res = await client.getJson(`${cardId}/messages/groups`, {
    maxRetries: 3,
    isRetryable: /* @__PURE__ */ __name(() => true, "isRetryable"),
    delayStrategy: {
      getDelay: /* @__PURE__ */ __name(() => 500, "getDelay")
    }
  });
  if (res?.body === void 0) {
    return [];
  }
  return Object.values(res.body).map((it) => deserializeMessageGroup(it)).sort((a, b) => a.fromDate.getTime() - b.fromDate.getTime());
}
__name(loadMessagesGroups, "loadMessagesGroups");
function deserializeMessageGroup(group) {
  return {
    cardId: group.cardId,
    blobId: group.blobId,
    fromDate: new Date(group.fromDate),
    toDate: new Date(group.toDate),
    count: group.count
  };
}
__name(deserializeMessageGroup, "deserializeMessageGroup");
async function loadMessages(client, blobId, params, options) {
  const { cardId } = params;
  const res = await client.getJson(`${cardId}/messages/${blobId}`, {
    maxRetries: 3,
    isRetryable: /* @__PURE__ */ __name(() => true, "isRetryable"),
    delayStrategy: {
      getDelay: /* @__PURE__ */ __name(() => 500, "getDelay")
    }
  });
  if (res?.body === void 0) {
    return [];
  }
  return parseMessagesDoc(res.body, params, options);
}
__name(loadMessages, "loadMessages");
function parseMessagesDoc(json, params, options) {
  let messages = {};
  if (params.id != null) {
    const value = json.messages[params.id];
    if (value == null) {
      return [];
    }
    messages = {
      [params.id]: value
    };
  } else {
    messages = json.messages;
  }
  const result = [];
  for (const m of Object.values(messages)) {
    if (params.limit != null && result.length >= params.limit) break;
    const message = {
      id: m.id,
      cardId: m.cardId,
      created: new Date(m.created),
      creator: m.creator,
      type: m.type,
      content: m.content,
      extra: m.extra,
      modified: m.modified != null ? new Date(m.modified) : void 0,
      reactions: {},
      attachments: [],
      threads: []
    };
    if (options?.reactions === true) {
      for (const [emoji, users] of Object.entries(m.reactions)) {
        for (const [user, data] of Object.entries(users)) {
          const messageData = message.reactions[emoji] ?? [];
          messageData.push({
            count: Number(data.count),
            person: user,
            date: new Date(data.date)
          });
          message.reactions[emoji] = messageData;
        }
      }
    }
    if (options?.attachments === true) {
      for (const attachment of Object.values(m.attachments)) {
        message.attachments.push({
          id: attachment.id,
          mimeType: attachment.mimeType,
          params: attachment.params,
          creator: m.creator,
          created: new Date(m.created)
        });
      }
    }
    if (options?.threads === true) {
      for (const thread of Object.values(m.threads)) {
        message.threads.push({
          cardId: m.cardId,
          messageId: m.id,
          threadId: thread.threadId,
          threadType: thread.threadType,
          repliesCount: Number(thread.repliesCount),
          lastReplyDate: thread.lastReplyDate != null ? new Date(thread.lastReplyDate) : void 0,
          repliedPersons: thread.repliedPersons
        });
      }
    }
    result.push(message);
  }
  if (params.order === import_communication_types.SortingOrder.Ascending) {
    result.sort((a, b) => a.created.getTime() - b.created.getTime());
  } else if (params.order === import_communication_types.SortingOrder.Descending) {
    result.sort((a, b) => b.created.getTime() - a.created.getTime());
  }
  return result;
}
__name(parseMessagesDoc, "parseMessagesDoc");
//# sourceMappingURL=utils.js.map
